import {compose, setDisplayName, withStateHandlers} from "recompose";
import {connect} from "react-redux";
import React from "react";
import {Scrollbars} from "react-custom-scrollbars";
import axios from "axios";
import {CLOUD_URL, fontSizes, highlightColors} from "../../../constants";
import * as $ from "jquery";
import {MobiFile} from './utilities/mobi';
import mammoth from "mammoth-style";
import {
  addNote, addPrevState, appearenceTextSize, deleteNote,
  highlightAction, removePrevState, replaceState,
  setBookLoadingProgress,
  setBookReady, setChapters, setCurrChapter, setCurrPage, setEditNoteText,
  setFullscreenMode, setInBookmarks, setOpenAddNote, setPageCount,
  setSearchResult, setSelectedNote, updateNote, updateReadPosition
} from "../../../actions/reader";
import {parseHtml} from '../../../utilities/otherUtilities'

import {
  nextPage,
  prevPage,
  fixTextPosition,
  getCurrPage,
  getFb2Position,
  findOffset,
  getFb2Offs,
  getFb2Over,
  checkIfTable,
  createSelection,
  getOffset,
  createHighlight,
  addNoteInPage, proxyMouse, getPageInSelectedRange, fb2Search, saveSelection
} from "../../../utilities/fb2Utilities";
import {nextDropdown} from "../../../actions/dropdown";
import {
  closePopups,
  dateForSaveNote,
  getStateIndex,
  getWidthByFontSize,
  notChildren, onMouseUp
} from "../../../utilities/utilities";

import '../Fb2Reader/Fb2Reader.css'
import './OtherReader.css'
import * as events from "events";
import {Navigation} from "../../Reader/components/Navigation/Navigation";
import {Pagination} from "../../Reader/components/Pagination/Pagination";
import {HighlightModal} from "../../Reader/components/HighlighModal/HighlightModal";
import * as Mark from "mark.js";
import {isEqual} from "../../../utilities/pdfUtilities";

const mapStateToProps = (state) => ({
  bookId: state.reader.bookId,
  bookInfo: state.reader.bookInfo,
  bookUrl: state.reader.bookUrl,
  bookData: state.reader.book,
  textColor: state.appearence.color,
  textSize: state.appearence.size,
  textFont: state.appearence.font,
  textFlow: state.appearence.flow,
  activeHighlight: state.reader.activeHighlight,
  pageCount: state.reader.pageCount,
  currPage: state.reader.currPage,
  access_token: state.reader.userData.access_token,
  refresh_token: state.reader.userData.refresh_token,
  bookmarks: state.reader.bookmarks,
  chapters: state.reader.chapters,
  highlights: state.reader.highlights,
  language: state.userData.language,
  prevStates: state.reader.prevStates,
  searchRequest: '',
  bookReady: state.reader.bookReady,
  selectedNote: state.reader.selectedNote
})

const mapDispatchToProps = (dispatch) => ({
  setBookReady: (status) => dispatch(setBookReady(status)),
  setBookLoadingProgress: (progress) => dispatch(setBookLoadingProgress(progress)),
  setFullscreenMode: (status) => dispatch(setFullscreenMode(status)),
  nextDropdown: (id) => dispatch(nextDropdown(id)),
  toggleActiveHighlight: (status) => dispatch(highlightAction(status)),
  setSearchResult: (result) => dispatch(setSearchResult(result)),
  setOpenAddNote: (status) => dispatch(setOpenAddNote(status)),
  addNote: (note, path, isHighlight) => dispatch(addNote(note, path, isHighlight)),
  setPageCount: (count) => dispatch(setPageCount(count)),
  setCurrPage: (page) => dispatch(setCurrPage(page)),
  updateReadPosition: (read_position, id) => dispatch(updateReadPosition(read_position, id)),
  setChapters: (chapters) => dispatch(setChapters(chapters)),
  setInBookmarks: (status) => dispatch(setInBookmarks(status)),
  setCurrChapter: (chapter) => dispatch(setCurrChapter(chapter)),
  setEditNoteText: (text) => dispatch(setEditNoteText(text)),
  addPrevState: (page, location, index) => dispatch(addPrevState(page, location, index)),
  removePrevState: () => dispatch(removePrevState()),
  replaceState: (state, index) => dispatch(replaceState(state, index)),
  deleteNote: (id, path, type ) => dispatch(deleteNote(id, path, type )),
  updateNote: (id, note, path) => dispatch(updateNote(id, note, path)),
  setSize: (size) => dispatch(appearenceTextSize(size)),
  setSelectedNote: (note) => dispatch(setSelectedNote(note))
})

const state = {
  pages: [],
  scrollTimes: 0,
  resizeInit: false,
  backButton: {
    status: false,
    page: 1,
    location: 0
  },
  forwardButton: {
    status: false,
    page: 1,
    location: 0
  },
  stateIndex: 0,
  eventEmmiter: {},
  marks: []
}

const stateHandlers = {
  onSaveReaderPosition: ({currPage}, {pageCount, updateReadPosition, bookId}) => (closeReader = false) => {
    const percent = Math.ceil(currPage*100/pageCount)
    const read_position = {
      pointer_pb: "pbr:/word?page=" + (currPage-1),
      offs: percent,
      page: currPage
    }

    if (percent !== 0) {
      updateReadPosition(read_position, bookId)
    }
    if (closeReader) {
      setTimeout(() => {
        window.location = CLOUD_URL
      }, 1500)
    }
  },
  onAddBookMark: ({currPage}, {setInBookmarks, bookmarks, bookId, addNote}) => () => {
    let isNew = true
    let note = {
      type: {
        value: "bookmark",
        updated: dateForSaveNote()
      },
      mark: {
        anchor: 'pbr:/word?page=' + (currPage-1),
        created:  Math.round(new Date() / 1000),
        updated: dateForSaveNote()
      }
    }

    for (let i=0; i < bookmarks.length; i++) {
      let bookmark = bookmarks[i]
      if (bookmark.mark.anchor === note.mark.anchor) {
        isNew = false
      }
    }

    if (isNew) {
      addNote(note, bookId)
      setInBookmarks(true)
    }
    window.getSelection().removeAllRanges()
  },
  onDeleteNote: ({selectedRange, selectedHighlight, rendition}, {selectedNote, highlights, bookId, deleteNote}) => (note, isHighlight = false) => {
    if (!note && Object.keys(selectedNote).length > 0) {
      note = selectedNote
      isHighlight = true
    }

    if ( note ) {
      if ( isHighlight ) {
        let begin = getFb2Offs(note.quotation.begin)
        let end = getFb2Over(note.quotation.end)

        if (!note.uuid) {
          highlights.map(h => {
            if (h.quotation.begin === note.quotation.begin &&
                h.quotation.end === note.quotation.end) {
              note.uuid = h.uuid
            }
            return h
          })
        }

        let marks = document.getElementsByClassName('mark')
        for(let i=0; i<marks.length;i++) {
          let mark = marks[i]
          let mBegin = parseInt(mark.dataset.begin, 10)
          let mEnd = parseInt(mark.dataset.end, 10)
          let mUuid = mark.dataset.uuid ? mark.dataset.uuid : ''
          if ((mBegin === begin && mEnd === end) || mUuid === note.uuid) {
            mark.remove()
          }
        }

        let rects = rendition.selectAll('rect')._groups[0]
        for (let i=0; i < rects.length; i++) {
          let rect = rects[i]
          let rOffs = parseInt(rect.dataset.begin, 10)
          let rOver = parseInt(rect.dataset.end, 10)
          let uuid = rect.dataset.uuid
          if ((rOffs === begin && rOver === end) || uuid === note.uuid) {
            rect.parentElement.remove()
            break
          }
        }
        deleteNote(note.uuid, bookId, true)
      } else {
        deleteNote(note.uuid, bookId)
      }
    }
  },
  onLoadHighlight: ({findCurrPage, onSaveReaderPosition, currPage, stateIndex}, {prevStates, addPrevState, textFlow}) => (anchor) => {
    let page = getFb2Position(anchor)
    let isTable = checkIfTable($('table[page-num="'+page+'"]'))
    let offs = getFb2Offs(anchor)

    let currOffs = findOffset(currPage, textFlow)
    let index = getStateIndex(prevStates, {page: currPage, location: currOffs})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, currOffs, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: currOffs}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: currOffs}, null,
        document.URL);

    if (isTable) {
      let el = $('table[page-num="'+page+'"]')[0]
      fixTextPosition(el, textFlow, null, 'el')
    } else if (offs) {
      findCurrPage(true, page, offs)
    } else {
      findCurrPage(true, page)
    }

    onSaveReaderPosition()
    return {
      backButton: {status: true, page: currPage, location: currOffs},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onLoadBookMark: ({findCurrPage, onSaveReaderPosition, currPage, stateIndex},
                   {prevStates, addPrevState, textFlow}) => (anchor) => {
    let page = getFb2Position(anchor)
    let offs = getFb2Offs(anchor)

    let currOffs = findOffset(currPage, textFlow)
    let index = getStateIndex(prevStates, {page: currPage, location: currOffs})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, currOffs, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: currOffs}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: currOffs}, null,
        document.URL);

    if (offs) {
      findCurrPage(true, page, offs)
    } else {
      findCurrPage(true, page)
    }
    onSaveReaderPosition()
    return {
      backButton: {status: true, page: currPage, location: currOffs},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onChangeChapter: ({findCurrPage, onSaveReaderPosition, currPage, stateIndex}, {prevStates, addPrevState, textFlow, setSearchResult}) => (value) => {
    let type = 'id'
    let page = value.chapterIndex
    if (value.selectedRange) {
      let selectedRange = value.selectedRange
      type = 'el'
      if (selectedRange.startContainer.nodeType === 3) {
        page = selectedRange.startContainer.parentElement
      } else {
        page = selectedRange.startContainer
      }
      setSearchResult([])
    }

    let offs = findOffset(currPage, textFlow)
    let index = getStateIndex(prevStates, {page: currPage, location: offs})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, offs, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: offs}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: offs}, null,
        document.URL);
    fixTextPosition(page, textFlow, null, type)
    findCurrPage()
    onSaveReaderPosition()
    return {
      backButton: {status: true, page: currPage, location: offs},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  setPages: () => (pages) => {
    return {pages: pages}
  },
  onLoad: () => (ref) => {
    return {rendition: ref}
  },
  onRenderPage: ({setPages, onLoadChapters, onLoad, onChangeTextSize, onChangeTextColor,
                   onChangeTextFont, onChangeViewMode, findCurrPage, onSaveReaderPosition,
                   onAddHighlights, addState},
                 {bookUrl, textSize, setBookLoadingProgress, bookData, setPageCount, setBookReady, textFlow, textColor,
                   textFont, currPage, updateReadPosition, bookId, access_token, refresh_token, bookInfo: {format}}) => () => {
      const config = {
          onDownloadProgress: progressEvent => {
              let progress = Math.ceil((progressEvent.loaded*100)/bookData.bytes)
              if (progress !== 'NaN') {
                setBookLoadingProgress(progress)
              }
          },
          responseType: 'arraybuffer'
      }

      axios.get(bookUrl, config).then(res => {
        let data = res.data;

        if (format === 'mobi') {
          let file = new MobiFile(data)
          file.load()
          parseHtml(file.read_text(), setPageCount, setPages, setBookReady, onLoadChapters, textFlow, onLoad,
            onChangeTextSize, textSize, onChangeTextColor, textColor, onChangeTextFont,
            textFont, onChangeViewMode, findCurrPage, currPage, onSaveReaderPosition,
            updateReadPosition, bookId, access_token, refresh_token, onAddHighlights, addState, file, format)

          let bookDom = document.getElementsByClassName('xml-page')[0];
          let imgDoms = bookDom.getElementsByTagName("img");
          for (let i = 0 ;i < imgDoms.length; i++) {
            file.render_image(imgDoms, i);
          }
          let linksDoms = bookDom.getElementsByTagName("a");
          for (let i = 0 ;i < linksDoms.length; i++) {
            file.render_link(linksDoms, i);
          }
        } else if (format === 'docx') {
          let options = {
            styleMap: [
              "p[style-name='Title'] => h2.title"
            ]
          };
          mammoth.convertToHtml({arrayBuffer: data}, options)
              .then(function(result){
                parseHtml(result.value, setPageCount, setPages, setBookReady, onLoadChapters, textFlow, onLoad,
                    onChangeTextSize, textSize, onChangeTextColor, textColor, onChangeTextFont,
                    textFont, onChangeViewMode, findCurrPage, currPage, onSaveReaderPosition,
                    updateReadPosition, bookId, access_token, refresh_token, onAddHighlights, addState, false, format)
              })
              .done();
        }
      })
  },
  onScroll: ({findCurrPage, onNextPage, onPrevPage, onSaveReaderPosition, prevPage, currPage}, {textFlow}) => (e) => {
      if (textFlow === 'scrolling') {
          if (e.top === 1) {
              onNextPage()
          } else if (e.top === 0) {
              onPrevPage()
          }
          findCurrPage()
          if (prevPage !== currPage) {
              onSaveReaderPosition()
              prevPage = currPage
          }
          return {prevPage: prevPage}
      }
  },
  onNextPage: ({findCurrPage, onSaveReaderPosition, currPage}, {textFlow}) => () => {
    nextPage(textFlow)
    findCurrPage()
    onSaveReaderPosition()
  },
  onPrevPage: ({findCurrPage, onSaveReaderPosition, currPage}, {textFlow}) => () => {
    prevPage(textFlow)
    findCurrPage()
    onSaveReaderPosition()
  },
  onChangeTextSize: ({onAddHighlights, currPage, onChangeViewMode}, {textSize, textFlow, setSize}) => (size, isLoad = false) => {
    let xmlPage = document.getElementsByClassName('xml-page')[0]

    textSize = parseInt(textSize, 10)
    if (typeof size === 'boolean') {
      let index = fontSizes.indexOf(textSize)
      if (size) {
        let fontSizesLeng = fontSizes.length-1
        index++
        if (index > fontSizesLeng) return
      } else {
        index--
        if (index < 0) return
      }
      size = fontSizes[index]
    }

    xmlPage.style.fontSize = size + 'px'
    if (!isLoad) onAddHighlights()

    let textWrap = document.getElementsByClassName('textWrap')[0]
    let annotationLayer = document.getElementsByClassName('svgWrapper')[0]
    let noteLayer = document.getElementsByClassName('noteLayer')[0]
    if (textFlow === '2page') {
      xmlPage.style.width = textWrap.scrollWidth + 44 + 'px'
      annotationLayer.style.width = textWrap.scrollWidth + 44 + 'px'
      noteLayer.style.width = textWrap.scrollWidth + 44 + 'px'
    } else if (textFlow === '1page') {
      xmlPage.style.width = textWrap.scrollWidth + 33 + 'px'
      annotationLayer.style.width = textWrap.scrollWidth + 33 + 'px'
      noteLayer.style.width = textWrap.scrollWidth + 33 + 'px'
    } else {
      xmlPage.style.width = '100%'
      annotationLayer.style.width = '100%'
      noteLayer.style.width = '100%'
    }

    setSize(size)
    onChangeViewMode(textFlow)
    fixTextPosition(currPage, textFlow)
  },
  onLoadChapters: ({pages}, {setChapters}) => () => {
    let sections = pages.storages
    let index = 0

    const Chapter = (label, page, chapterIndex, subitems) => ({
      label: label,
      href: {
        page: page,
        chapterIndex: chapterIndex
      },
      page: page,
      subitems: subitems
    })

    const getChapterIndex = (el) => {
      let chapterIndex
      if (el.getAttribute('id')) {
        chapterIndex = el.getAttribute('id')
      } else {
        index++
        chapterIndex = 'chapter-link-'+index
        el.setAttribute('id', chapterIndex)
      }
      return chapterIndex
    }

    const getTitle = (el) => {
      return $(el).text().trim()
        .replace(/\s\s+/g, ' ')
    }

    const getPage = (el) => {
      let page = ''
      if ($(el).hasClass('title')) {
        el = el.children[0]
      }
      page = parseInt(el.getAttribute('page-num'), 10)
      return page
    }

    const getChapters = (sections, chapters = []) => {
      for (let i=0; i < sections.length; i++) {
        let section = sections[i]
        let title = ''
        let subitems = []
        let page = ''
        let chapterIndex

        if (section.nodeName.toLowerCase() === 'section') {
          let children = section.children
          if (children[0] && children[0].nodeName.toLowerCase() !== 'section') {
            title = getTitle(children[0])
            page = getPage(children[0])
            chapterIndex = getChapterIndex(children[0])
          }
          subitems = getChapters(children)
        } else if (section.nodeName.toLowerCase() !== 'section') continue

        if (title.length > 0) {
          chapters.push(Chapter(title, page, chapterIndex, subitems))
        } else {
          chapters = chapters.concat(subitems)
        }
      }
      return chapters
    }

    setChapters(getChapters(sections))
  },
  onChangeTextColor: () => (bgClass) => {
    document.getElementsByTagName('body')[0].className = bgClass
  },
  onChangeTextFont: ({onAddHighlights, currPage}, {textFlow}) => (font, isLoad = false) => {
    let xmlPage = document.getElementsByClassName('xml-page')[0]
    let fontInLine = font === 'inherit' ? 'Times New Roman' : font + ', sans-serif'
    xmlPage.style.fontFamily = fontInLine
    if (!isLoad) onAddHighlights()

    let count = 0
    let wait = setInterval(() => {
      let textWrap = document.getElementsByClassName('textWrap')[0]
      let annotationLayer = document.getElementsByClassName('svgWrapper')[0]
      let noteLayer = document.getElementsByClassName('noteLayer')[0]

      if (!textWrap) return
      if (textFlow === '2page') {
        xmlPage.style.width = textWrap.scrollWidth + 44 + 'px'
        annotationLayer.style.width = textWrap.scrollWidth + 44 + 'px'
        noteLayer.style.width = textWrap.scrollWidth + 44 + 'px'
      } else if (textFlow === '1page') {
        xmlPage.style.width = textWrap.scrollWidth + 33 + 'px'
        annotationLayer.style.width = textWrap.scrollWidth + 33 + 'px'
        noteLayer.style.width = textWrap.scrollWidth + 33 + 'px'
      } else {
        xmlPage.style.width = '100%'
        annotationLayer.style.width = '100%'
        noteLayer.style.width = '100%'
      }

      fixTextPosition(currPage, textFlow)
      if (count === 5) {
        clearInterval(wait)
      }
      count++
    }, 200)
  },
  onChangeViewMode: ({currPage, findCurrPage, onAddHighlights}, {textSize}) => (view, isLoad = false, textFlow) => {
    let pageClass
    let xmlPage = document.getElementsByClassName('xml-page')[0]
    let viewer = document.getElementById('viewer')
    let viewerContent = document.getElementById('viewer-content')
    let readerContent = document.getElementsByClassName('fb2Reader')[0]
    let pageInScroll
    if (textFlow === 'scrolling') pageInScroll = getCurrPage(currPage, textFlow, true)

    switch(view) {
      case '1page':
        pageClass = 'one-page'
        break;
      case '2page':
        pageClass = 'two-page'
        break;
      case 'scrolling':
        pageClass = view
        break;
      default:
        pageClass = ''
    }

    xmlPage.classList = 'xml-page ' + pageClass
    viewerContent.classList = pageClass
    readerContent.classList = 'fb2Reader ' + pageClass

    viewer.style.maxWidth = ''
    let vWidth = viewerContent.offsetWidth
    if (view !== '2page') {
      vWidth = getWidthByFontSize(textSize)
      viewer.style.maxWidth = vWidth + 'px'
    }
    let textWrap = document.getElementsByClassName('textWrap')[0]
    let annotationLayer = document.getElementsByClassName('svgWrapper')[0]
    let noteLayer = document.getElementsByClassName('noteLayer')[0]

    if (view === '2page') {
      textWrap.style.columnWidth = ((vWidth/2) - 88*2) + 'px'
      textWrap.style.width = vWidth + 'px'
      xmlPage.style.width = textWrap.scrollWidth + 44 + 'px'
      annotationLayer.style.width = textWrap.scrollWidth + 44 + 'px'
      noteLayer.style.width = textWrap.scrollWidth + 44 + 'px'
    } else if (view === '1page') {
      textWrap.style.columnWidth = (vWidth - 66*2) + 'px'
      textWrap.style.width = vWidth + 'px'
      xmlPage.style.width = textWrap.scrollWidth + 33 + 'px'
      annotationLayer.style.width = textWrap.scrollWidth + 33 + 'px'
      noteLayer.style.width = textWrap.scrollWidth + 33 + 'px'
    } else {
      textWrap.style.columnWidth = ''
      textWrap.style.width = vWidth + 'px'
      xmlPage.style.width = '100%'
      annotationLayer.style.width = '100%'
      noteLayer.style.width = '100%'
    }

    findCurrPage(true, currPage, false, false, pageInScroll)
    if (!isLoad) onAddHighlights()
  },
  findCurrPage: ({pages, currPage, stateIndex}, {prevStates, replaceState, textFlow, chapters, setInBookmarks,
    bookmarks, setCurrChapter}) => (isLoad = false, nextPage, offs = false, type = false, pageInScroll = false) => {
    setInBookmarks(false)
    setCurrChapter('')

    let viewerContent = document.getElementById('viewer-content')
    let viewer = document.getElementById('viewer')
    let page = currPage
    if (nextPage) {
      page = nextPage
    }

    if (!isLoad && !nextPage) {
      page = getCurrPage(page, textFlow)
    } else {
      fixTextPosition(pageInScroll ? pageInScroll : page, textFlow, offs, 'note')
    }

    let container = document.getElementById('viewer-content')
    if (textFlow === 'scrolling') container = document.getElementById('viewer')
      .getElementsByTagName('div')[0]
      .getElementsByTagName('div')[0]
    let limit = textFlow === 'scrolling' ? viewer.offsetHeight + viewer.offsetTop : container.offsetWidth
    for (let i=0; i< bookmarks.length; i++) {
      let bookmark = bookmarks[i]
      let bookmarkPage = getFb2Position(bookmark.mark.anchor)
      let el = $('[page-num="'+bookmarkPage+'"]')[0]
      let offs = textFlow === 'scrolling' ? $(el).offset().top : $(el).offset().left
      if (offs > 0 && offs < limit) {
        setInBookmarks(true)
      }
    }

    let overLimit = viewerContent.offsetWidth
    let scrollOffs = window.pageXOffset || document.documentElement.scrollLeft
    if (textFlow === 'scrolling') {
      overLimit = viewer.offsetHeight + viewer.offsetTop
      scrollOffs = window.pageYOffset || document.documentElement.scrollTop
    }

    const getVisibleChapters = (arr, level = -1, parentIndexes = []) => {
      level++
      for (let i=0; i < arr.length; i++) {
        let chapter = arr[i]
        let id = chapter.href.chapterIndex
        if (level === 0) {
          parentIndexes = []
        }
        parentIndexes[level] = i
        if (!document.getElementById(id)) continue
        let rect = document.getElementById(id).getBoundingClientRect();
        let left = textFlow === 'scrolling' ? rect.top + scrollOffs : rect.left + scrollOffs

        if (left < overLimit) {
          let ids = [id]
          let parent = false

          for (let l=0; l < parentIndexes.length; l++) {
            let index = parentIndexes[l]
            if (l === 0) {
              parent = chapters[index]
            }
            if (parent) {
              ids.push(parent.href.chapterIndex)
            }
          }
          setCurrChapter(ids)
        }

        if (chapter.subitems.length > 0) {
          getVisibleChapters(chapter.subitems, level, parentIndexes)
        }
      }
    }
    getVisibleChapters(chapters)

    let currOffs = findOffset(page, textFlow)
    let index = getStateIndex(prevStates, {page: page, location: currOffs})
    let statePage = index > 0 ? page +'-'+ index : page
    if (stateIndex > 0) {
      let indexPage = prevStates[stateIndex].page
      if (indexPage.toString().indexOf('-') > -1) {
        indexPage = indexPage.split('-')[0]
      }
      if (indexPage === page) {
        statePage = indexPage
      } else {
        index = getStateIndex(prevStates, {page: page, location: currOffs}, 0)
        statePage = index > 0 ? page + '-' + index : page
      }
    }
    replaceState({page: statePage, location: currOffs}, stateIndex)
    window.history.replaceState({page: statePage, location: currOffs}, null,
      document.URL);
    //if (textFlow !== 'scrolling') fixTextPosition(page, textFlow, currOffs, 'note')
    return {currPage: page}
  },
  onAddHighlights: ({rendition, onSelected, changeHighlighModalPosition, eventEmmiter}, {highlights, setEditNoteText,
    toggleActiveHighlight, activeHighlight, setOpenAddNote, textFlow, setSelectedNote}) => () => {
    let svg = document.getElementsByClassName('svgWrapper')[0]
      .getElementsByTagName('svg')[0]
    let noteLayer = document.getElementsByClassName('noteLayer')[0]
    svg.innerHTML = ''
    noteLayer.innerHTML = ''
    let marks = []

    for (let i=0; i < highlights.length; i++) {
      let note = highlights[i]
      if (!note.quotation.begin) continue
      let begin = getFb2Offs(note.quotation.begin)
      let end = getFb2Over(note.quotation.end)
      let pageBegin = getFb2Position(note.quotation.begin)
      let pageEnd = getFb2Position(note.quotation.end)
      let text = note.quotation.text

      if (pageBegin <= 0 || pageEnd <= 0) continue
      let color = ''
      let h = {}
      let isTable = checkIfTable($('table[page-num="'+pageBegin+'"]'))
      let selectedRange = createSelection(pageBegin, pageEnd, begin, end, isTable)

      if (note.note) {
        color = highlightColors[note.color ? note.color.value : 'red']
        let noteText = note.note.text
        let offs = getOffset(selectedRange, pageBegin, pageEnd, isTable)
        h = createHighlight(rendition, selectedRange, text, color, pageBegin, pageEnd, note.uuid, isTable, eventEmmiter, offs)
        addNoteInPage(selectedRange, note, setSelectedNote, pageBegin, offs, noteText, text, onSelected, setEditNoteText, changeHighlighModalPosition,
          toggleActiveHighlight, activeHighlight, setOpenAddNote, note.uuid, isTable)
      } else {
        color = highlightColors[note.color ? note.color.value : 'yellow']
        h = createHighlight(rendition, selectedRange, text, color, pageBegin, pageEnd, note.uuid, isTable, eventEmmiter)
      }

      let emitter = function emmiter() {
        eventEmmiter.emit('markClicked', note)
      }

      if (h.g) {
        h.g.addEventListener("mousedown", emitter)
        h.g.addEventListener("mouseup", emitter)
        marks.push(h.g)
      }
    }

    let viewerContent = document.getElementById('viewer-content')
    proxyMouse(viewerContent, marks)

    return {marks: marks}
  },
  onSelected: () => (range = '', text = '', uuid = '', target = '', coords = '') => {
    if (!range) return
    return {
      selectedRange: range,
      selectedText: text,
      selectedHighlight: uuid,
      target: target,
      coords: coords
    }
  },
  onSelectedColor: () => (color) => (
      {selectedHighlightColor: color}
  ),
  onAddNote: ({marks, rendition, onSelected, target, selectedRange, selectedText, selectedHighlightColor, eventEmmiter}, {selectedNote, addNote, bookId, highlights, updateNote, setSelectedNote}) => (onSelected, isUpdate) => {
    let note = {}
    let h = {}
    let color = highlightColors[selectedHighlightColor]

    if (isUpdate) {
      note = selectedNote
      note.color.value = selectedHighlightColor
      note.color.updated = dateForSaveNote()

      if (!note.uuid) {
        highlights.forEach(highlight => {
          if (highlight.quotation.begin === note.quotation.begin &&
              highlight.quotation.end === note.quotation.end) {
            note.uuid = highlight.uuid
          }
        })
      }

      let begin = getFb2Offs(note.quotation.begin)
      let end = getFb2Over(note.quotation.end)
      let pageBegin = getFb2Position(note.quotation.begin)
      let pageEnd = getFb2Position(note.quotation.end)
      let text = note.quotation.text

      let isTable = checkIfTable($('table[page-num="'+pageBegin+'"]'))
      let selectedRange = createSelection(pageBegin, pageEnd, begin, end, isTable)

      updateNote(note.uuid, note, bookId)
      setSelectedNote(note)

      let rects = rendition.selectAll('rect')._groups[0]
      for (let i=0; i < rects.length; i++) {
        let rect = rects[i]
        let rOffs = parseInt(rect.dataset.begin, 10)
        let rOver = parseInt(rect.dataset.end, 10)
        if (rOffs === begin && rOver === end) {
          rect.parentElement.remove()
          break
        }
      }

      h = createHighlight(rendition, selectedRange, text, color, pageBegin, pageEnd, note.uuid, isTable, eventEmmiter)
    } else {
      let pages = getPageInSelectedRange(selectedRange)

      let pageStart = pages.start
      let pageEnd = pages.end
      h = createHighlight(rendition, selectedRange, selectedText, color, pageStart+1, pageEnd+1, false, pages.isTable, eventEmmiter)
      let begin = h.offs.start
      let end = h.offs.end

      note = {
        type: {
          value: "highlight",
          updated: dateForSaveNote()
        },
        color: {
          value: selectedHighlightColor,
          updated: dateForSaveNote()
        },
        mark: {
          anchor: "pbr:/char?page="+pageStart+"&offs="+begin,
          created:  Math.round(new Date() / 1000),
          updated: dateForSaveNote()
        },
        quotation: {
          begin: "pbr:/char?page="+pageStart+"&offs="+begin,
          end: "pbr:/char?page="+pageEnd+"&over="+end,
          text: selectedText,
          updated: dateForSaveNote()
        }
      }
      addNote(note, bookId, true)
    }

    let emitter = function emmiter() {
      eventEmmiter.emit('markClicked', note)
    }
    h.g.addEventListener("mousedown", emitter)
    h.g.addEventListener("mouseup", emitter)
    marks.push(h.g)

    let viewerContent = document.getElementById('viewer-content')
    proxyMouse(viewerContent, marks)

    return {marks: marks}
  },
  onUpdateNote: ({marks, rendition, selectedRange, eventEmmiter}, {selectedNote, highlights, setEditNoteText,
    toggleActiveHighlight, activeHighlight, setOpenAddNote, textFlow, bookId, addNote, updateNote,
    setSelectedNote}) => (noteText, onSelected, changeHighlighModalPosition) => {
    let note = {}
    let selectedText = ''
    let pageBegin
    let pageEnd
    let isTable = false
    let uuid = false
    let offs = {}

    if (Object.keys(selectedNote).length > 0) {
      note = selectedNote
      let begin = getFb2Offs(note.quotation.begin)
      let end = getFb2Over(note.quotation.end)
      pageBegin = getFb2Position(note.quotation.begin)
      pageEnd = getFb2Position(note.quotation.end)
      isTable = checkIfTable($('table[page-num="'+pageBegin+'"]'))
      selectedText = note.quotation.text

      selectedRange = createSelection(pageBegin, pageEnd, begin, end, isTable)
      offs = getOffset(selectedRange, pageBegin, pageEnd, isTable)

      note.type = {
        value: "note",
        updated: dateForSaveNote()
      }
      note.note = {
        text: noteText,
        updated: dateForSaveNote()
      }

      if (!note.uuid) {
        highlights.forEach(highlight => {
          if (highlight.quotation.begin === note.quotation.begin &&
              highlight.quotation.end === note.quotation.end) {
            note.uuid = highlight.uuid
          }
        })
      }
      uuid = note.uuid

      updateNote(note.uuid, note, bookId)

      let marks = document.getElementsByClassName('mark')
      for(let i=0; i<marks.length;i++) {
        let mark = marks[i]
        let mBegin = parseInt(mark.dataset.begin, 10)
        let mEnd = parseInt(mark.dataset.end, 10)
        if ((mBegin === begin && mEnd === end) || mark.dataset.uuid === note.uuid) {
          mark.remove()
        }
      }

      let rects = rendition.selectAll('rect')._groups[0]
      for (let i=0; i < rects.length; i++) {
        let rect = rects[i]
        let rOffs = parseInt(rect.dataset.begin, 10)
        let rOver = parseInt(rect.dataset.end, 10)
        let rUuid = rect.dataset.uuid
        if ((rOffs === begin && rOver === end) || rUuid === note.uuid) {
          rect.parentElement.remove()
          break
        }
      }
    } else {
      let pages = getPageInSelectedRange(selectedRange)
      pageBegin = pages.start+1
      pageEnd = pages.end+1
      selectedText = selectedRange.toString()
      isTable = pages.isTable
      offs = getOffset(selectedRange, pageBegin, pageEnd, isTable)
      let color = 'red'

      note = {
        type: {
          value: "note",
          updated: dateForSaveNote()
        },
        color: {
          value: color,
          updated: dateForSaveNote()
        },
        note: {
          text: noteText,
          updated: dateForSaveNote()
        },
        mark: {
          anchor: "pbr:/char?page="+(pageBegin-1)+"&offs="+offs.start,
          created:  Math.round(new Date() / 1000),
          updated: dateForSaveNote()
        },
        quotation: {
          begin: "pbr:/char?page="+(pageBegin-1)+"&offs="+offs.start,
          end: "pbr:/char?page="+(pageEnd-1)+"&over="+offs.end,
          text: selectedText,
          updated: dateForSaveNote()
        }
      }

      addNote(note, bookId, true)
    }

    let color = highlightColors[note.color ? note.color.value : 'red']
    let h = createHighlight(rendition, selectedRange, selectedText, color, pageBegin, pageEnd, false, isTable, eventEmmiter, offs)
    addNoteInPage(selectedRange, note, setSelectedNote, pageBegin, offs, noteText, selectedText, onSelected, setEditNoteText, changeHighlighModalPosition,
        toggleActiveHighlight, activeHighlight, setOpenAddNote, uuid, isTable)

    let emitter = function emmiter() {
      eventEmmiter.emit('markClicked', note)
    }
    h.g.addEventListener("mousedown", emitter)
    h.g.addEventListener("mouseup", emitter)
    marks.push(h.g)

    let viewerContent = document.getElementById('viewer-content')
    proxyMouse(viewerContent, marks)

    return {marks: marks}
  },
  addState: ({currPage, stateIndex}, {prevStates, textFlow, addPrevState}) => () => {
    let currOffs = findOffset(currPage, textFlow)
    let index = getStateIndex(prevStates, {page: currPage, location: currOffs})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, currOffs, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: currOffs}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: currOffs}, null,
        document.URL);
    return {
      backButton: {status: true, page: currPage, location: currOffs},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onResize: ({resizeInit, currPage, onAddHighlights}, {textFlow, textSize}) => () => {
    if (resizeInit) clearTimeout(resizeInit)
    resizeInit = setTimeout(() => {
      let viewerContent = document.getElementById('viewer-content')
      let viewer = document.getElementById('viewer')
      let xmlPage = document.getElementsByClassName('xml-page')[0]
      if (!xmlPage) return

      viewer.style.maxWidth = ''
      let vWidth = viewerContent.offsetWidth
      if (textFlow !== '2page') {
        vWidth = getWidthByFontSize(textSize)
        viewer.style.maxWidth = vWidth + 'px'
      }

      let textWrap = document.getElementsByClassName('textWrap')[0]
      if (!textWrap) return

      xmlPage.style.width = textWrap.scrollWidth + 'px'
      textWrap.style.width = vWidth + 'px'
      if (textFlow === '2page') {
        let w = vWidth/2 - 88*2
        if (w <= 224) w = vWidth - 66*2
        textWrap.style.columnWidth = w + 'px'
      } else if (textFlow === '1page') {
        textWrap.style.columnWidth = (vWidth - 66*2) + 'px'
      } else {
        textWrap.style.columnWidth = ''
      }
      textWrap.style.width = vWidth + 'px'
      fixTextPosition(currPage, textFlow)
      onAddHighlights()
    }, 500)
  },
  onChangeRangeComplete: ({onSaveReaderPosition, findCurrPage, currPage, pageOnChangeStart, stateIndex}, {prevStates, addPrevState, textFlow}) => (value) => {
    let currOffs = findOffset(pageOnChangeStart, textFlow)
    let index = getStateIndex(prevStates, {page: pageOnChangeStart, location: currOffs})
    let statePage = index > 0 ? pageOnChangeStart +'-'+ index : pageOnChangeStart
    addPrevState(statePage, currOffs, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: currOffs}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: currOffs}, null,
        document.URL);

    findCurrPage(true, value)
    onSaveReaderPosition()
    return {
      currPage: value,
      backButton: {status: true, page: pageOnChangeStart, location: currOffs},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onAddRangeRef: () => (ref) => (
      {rangeRef: ref}
  ),
  onChangeStart: () => (value) => ({
    pageOnChangeStart: value
  }),
  onChangeRange: () => (value) => ({
    currPage: value
  }),
  onSetPages: () => (setPages) => ({
    setPages: setPages
  }),
  onSearch: (state, {setSearchResult}) => (e, value) => {
    let q = ''
    if (!e) {
      q = value
    } else {
      q = e.target.value
    }

    let container = document.getElementById('viewer-content')
    let instance = new Mark(container)
    instance.unmark()

    if (q.length > 2) {
      setSearchResult(fb2Search(q, document.getElementsByClassName('textWrap')))
      instance.mark(q, {"separateWordSearch": false})
    } else {
      setSearchResult([])
    }

    return {searchRequest: q}
  },
  goBack: ({findCurrPage, onSaveReaderPosition, changeIndex}, {prevStates}) => (e) => {
    if (!e.state || !e.state.page || prevStates.length <= 1) {
      window.location = CLOUD_URL
      return
    }

    let state = e.state
    let page = state.page
    let offs = state.location
    let currIndex = 0

    for (let i=0; i < prevStates.length; i++) {
      let prevState = prevStates[i]
      if (isEqual(prevState, state)) {
        currIndex = i
        break
      }
    }

    let forwardButton = {status: false}
    if (currIndex !== 0) {
      forwardButton.status = true
      forwardButton.page = prevStates[currIndex-1].page
      if (forwardButton.page.toString().indexOf('-') > -1) {
        forwardButton.page = forwardButton.page.toString().split('-')[0]
      }
      forwardButton.location = prevStates[currIndex-1].location
    }

    let backButton = {status: false}
    if (currIndex !== (prevStates.length-1)) {
      backButton.status = true
      backButton.page = prevStates[currIndex+1].page
      if (backButton.page.toString().indexOf('-') > -1) {
        backButton.page = backButton.page.toString().split('-')[0]
      }
      backButton.location = prevStates[currIndex+1].location
    }

    changeIndex(currIndex)
    if (page.toString().indexOf('-') > -1) {
      page = page.toString().split('-')[0]
    }
    if (offs !== 0) {
      findCurrPage(true, page, offs)
    } else {
      findCurrPage(true, page)
    }
    onSaveReaderPosition()

    return {
      currPage: page,
      forwardButton: forwardButton,
      backButton: backButton
    }
  },
  onOpenHighlightModal: ({changeHighlighModalPosition, onSelected, selectedRange}, {selectedNote, setSearchResult, toggleActiveHighlight, activeHighlight, setOpenAddNote}) => (e, drag, selected) => {
    if (e.target.tagName.toLowerCase() === 'a'  || e.target.parentElement.tagName.toLowerCase() === 'a') {
      toggleActiveHighlight(false)
    } else if (drag && selected.length > 0) {
      setSearchResult([])
      let selectionRange = saveSelection();
      onSelected(selectionRange, selected, '' , e)
      if (!e.target.href || e.target.tagName.toLowerCase() !== 'a') {
        onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight,
            activeHighlight, onSelected, setOpenAddNote, '', true, true, drag)
      }
    } else if (selectedNote && Object.keys(selectedNote).length > 0) {
      setSearchResult([])
      onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight,
          activeHighlight, onSelected, setOpenAddNote, 'openEditHighlight', true, true, drag)
    } else {
      toggleActiveHighlight(false)
    }
  },
  onBackButton: () => () => {
    window.history.back()
  },
  onForwardButton: () => () => {
    window.history.forward()
  },
  changeIndex: () => (index) => ({
    stateIndex: index,
  }),
  setEvents: () => (events) => ({
    eventEmmiter: events
  }),
  setOnChangeTextColor: () => (onChangeTextColor) => ({
    onChangeTextColor: onChangeTextColor
  }),
  setOnChangeTextSize: () => (onChangeTextSize) => ({
    onChangeTextSize: onChangeTextSize
  }),
  setOnChangeTextFont: () => (onChangeTextFont) => ({
    onChangeTextFont: onChangeTextFont
  }),
  setOnChangeViewMode: () => (onChangeViewMode) => ({
    onChangeViewMode: onChangeViewMode
  }),
  setOnNextPage: () => (onNextPage) => ({
    onNextPage: onNextPage
  }),
  setOnPrevPage: () => (onPrevPage) => ({
    onPrevPage: onPrevPage
  }),
  setOnSelected: () => (onSelected) => ({
    onSelected: onSelected
  }),
  onFindCurrPage: () => (findCurrPage) => ({
    findCurrPage: findCurrPage
  }),
  setOnSaveReaderPosition: () => (onSaveReaderPosition) => ({
    onSaveReaderPosition: onSaveReaderPosition
  }),
  setOnLoadChapters: () => (onLoadChapters) => ({
    onLoadChapters: onLoadChapters
  }),
  setOnLoad: () => (onLoad) => ({
    onLoad: onLoad
  }),
  setOnAddHighlights: () => (onAddHighlights) => ({
    onAddHighlights: onAddHighlights
  }),
  setChangeHighlighModalPosition: () => (changeHighlighModalPosition) => ({
    changeHighlighModalPosition: changeHighlighModalPosition
  }),
  setAddState: () => (addState) => ({
    addState: addState
  }),
  setChangeIndex: () => (changeIndex) => ({
    changeIndex: changeIndex
  }),
}

export const enhance = compose(
    setDisplayName('Other Reader'),
    connect(mapStateToProps, mapDispatchToProps),
    withStateHandlers(state, stateHandlers)
)

export class View extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      highlightModalTop: 0,
      highlightModalLeft: 0
    }

    this.changeHighlighModalPosition = this.changeHighlighModalPosition.bind(this)
  }

  changeHighlighModalPosition(top, left) {
    this.setState({highlightModalTop: top, highlightModalLeft: left})
  }

  componentDidMount() {
    const {props: { onSetPages, setPages, onRenderPage, setFullscreenMode, nextDropdown,
      setOnChangeTextSize, onChangeTextSize, setOnChangeTextColor, onChangeTextColor,
      setOnChangeTextFont, onChangeTextFont, setOnChangeViewMode, onChangeViewMode, setOnNextPage,
      setOnPrevPage, onNextPage, onPrevPage, onResize, onSelected, setOnSelected, setCurrPage, bookInfo,
      onFindCurrPage, findCurrPage, setOnSaveReaderPosition, onSaveReaderPosition,
      setOnLoadChapters, onLoadChapters, onLoad, setOnLoad, setOnAddHighlights, onAddHighlights,
      setChangeHighlighModalPosition, setSearchResult, goBack, setAddState, addState,
      setChangeIndex, changeIndex, setEvents, setSelectedNote, onOpenHighlightModal,
      toggleActiveHighlight }} = this

    window.history.replaceState({'status': 'loaded'}, null, document.URL);
    window.history.pushState({'status': 'loaded'}, null, document.URL);

    onSetPages(setPages)
    setOnChangeTextColor(onChangeTextColor)
    setOnChangeTextSize(onChangeTextSize)
    setOnChangeTextFont(onChangeTextFont)
    setOnChangeViewMode(onChangeViewMode)
    setOnNextPage(onNextPage)
    setOnPrevPage(onPrevPage)
    setOnSelected(onSelected)
    onFindCurrPage(findCurrPage)
    setOnSaveReaderPosition(onSaveReaderPosition)
    setOnLoadChapters(onLoadChapters)
    setOnLoad(onLoad)
    setOnAddHighlights(onAddHighlights)
    setChangeHighlighModalPosition(this.changeHighlighModalPosition)
    setAddState(addState)
    setChangeIndex(changeIndex)

    if (bookInfo.position && bookInfo.position.pointer_pb) {
      let page = bookInfo.position.page ? bookInfo.position.page : getFb2Position(bookInfo.position.pointer_pb)
      setCurrPage(page)
    }
    onRenderPage()

    let fullscreenStatus = false
    const toggleFullscreen = () => {
      setFullscreenMode(!fullscreenStatus)
      fullscreenStatus = !fullscreenStatus
      const root = document.getElementById('root')
      root.classList.toggle('fullscreen')
    }

    if (document.addEventListener) {
      document.addEventListener('webkitfullscreenchange', toggleFullscreen, false);
      document.addEventListener('mozfullscreenchange', toggleFullscreen, false);
      document.addEventListener('fullscreenchange', toggleFullscreen, false);
      document.addEventListener('MSFullscreenChange', toggleFullscreen, false);

      closePopups(document, nextDropdown)

      document.addEventListener('keydown', (e) => {
        e = e || window.event

        if (e.keyCode === 38 || e.keyCode === 37 || e.keyCode === 33) {
          onPrevPage()
        }
        else if (e.keyCode === 40 || e.keyCode === 39 || e.keyCode === 34) {
          onNextPage()
        }
      })

      window.addEventListener('resize', () => {
        onResize()
      })

      let drag = false
      document.addEventListener('mousedown', e => {
        e.stopPropagation()
        closePopups(document, nextDropdown)

        let search = []
        let searchResultSelector = document.getElementsByClassName('Search__result')[0]
        if (searchResultSelector) {
          notChildren(search, e.target, searchResultSelector.children)
          if (!(search.indexOf(false) > -1)) {
            setSearchResult([])
          }
        }
        drag = false

        let marks = []
        let popup = []
        notChildren(marks, e.target, document.getElementsByClassName('mark'))
        notChildren(popup, e.target, document.getElementById('HighlightModal__wrapper').children)
        if (!(popup.indexOf(false)> -1) && !(marks.indexOf(false) > -1)) {
          toggleActiveHighlight(false)
          setSelectedNote({})
          onSelected('')

          let marks = document.getElementsByClassName('mark')
          for (let i=0; i< marks.length; i++) {
            let mark = marks[i]
            mark.classList.remove('open')
          }
        }
      })
      document.addEventListener('mousemove', e => {
        drag = true
      })
      document.addEventListener('mouseup', e => {
        let popup = []
        let bookInfo = []
        notChildren(bookInfo, e.target, document.getElementsByClassName('BookInfo').children)
        notChildren(popup, e.target, document.getElementById('HighlightModal__wrapper').children)
        if (!(popup.indexOf(false) > -1) && !(bookInfo.indexOf(false) > -1)) {
          let selected = window.getSelection().toString()
          onOpenHighlightModal(e, drag, selected)
        }
      })
    }

    window.addEventListener('popstate', (e) => {
      goBack(e)
    });

    let EventsEmitter = new events.EventEmitter()
    setEvents(EventsEmitter)
    EventsEmitter.on('markClicked', note => {
      setSelectedNote(note)
    })
  }

  render() {
      const {props: { currPage, onPrevPage, onNextPage, onChangeChapter, onLoadBookMark,
        onSaveReaderPosition, onChangeTextSize, onChangeTextColor, onChangeTextFont, onChangeViewMode, onLoadHighlight,
        onDeleteNote, rendition, onAddBookMark, addNote, onSearch, onScroll, activeHighlight, onAddNote, onSelectedColor,
        toggleActiveHighlight, onSetTextSelected, onUpdateNote, onSelected, onAddRangeRef, onChangeRange, backButton,
        forwardButton, onBackButton, onForwardButton, onChangeStart, onChangeRangeComplete, bookReady, selectedHighlightColor }} = this
      return (
          <div className="fb2Reader">
              { bookReady ?
                  <Navigation onChangeChapter={onChangeChapter} onLoadBookMark={onLoadBookMark}
                              onSaveReaderPosition={onSaveReaderPosition} onChangeTextSize={onChangeTextSize}
                              onChangeTextColor={onChangeTextColor} onChangeTextFont={onChangeTextFont}
                              onChangeViewMode={onChangeViewMode} onLoadHighlight={onLoadHighlight} onDeleteNote={onDeleteNote}
                              rendition={rendition} onAddBookMark={onAddBookMark} onSearch={onSearch}
                              onChangePage={onChangeChapter}/> :
                  ''
              }
              <button
                className="navigation-prev-page icon-btn"
                onClick={() => onPrevPage()}
              ></button>
              <button
                className="navigation-next-page icon-btn"
                onClick={() => onNextPage()}
              ></button>
              <div
                id="viewer"
                className="spreads large otherReader"
              >
                  <Scrollbars style={{ width: '100%', height: '100%' }}
                              onScrollFrame={(e) => onScroll(e)}
                              renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{display:"none"}}/>}
                  >
                      <div id="viewer-content"></div>
                  </Scrollbars>
              </div>
              <Pagination
                  backButton={backButton}
                  forwardButton={forwardButton}
                  onBackButton={onBackButton}
                  onForwardButton={onForwardButton}
                  onAddRangeRef={onAddRangeRef}
                  onChangeStart={onChangeStart}
                  onChangeRange={onChangeRange}
                  onChangeRangeComplete={onChangeRangeComplete}
                  currPage={currPage}
              />
              <HighlightModal
                  active={activeHighlight}
                  loading={false}
                  highlightModalTop={this.state.highlightModalTop}
                  highlightModalLeft={this.state.highlightModalLeft}
                  onAddBookMark={onAddBookMark}
                  onAddNote={onAddNote}
                  onSelectedColor={onSelectedColor}
                  addNote={addNote}
                  selectedColor={selectedHighlightColor}
                  toggleActiveHighlight={toggleActiveHighlight}
                  onDeleteNote={onDeleteNote}
                  onSelected={onSelected}
                  onSetTextSelected={onSetTextSelected}
                  onUpdateNote={onUpdateNote}
                  changeHighlighModalPosition={this.changeHighlighModalPosition}
              />
          </div>
      )
  }
}

export const OtherReader = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Formats/OtherReader/OtherReader.js